import { plugin as engagementPlugin } from '@amplitude/engagement-browser';

// this is a web specific plugin
// for more information,
// see https://amplitude.com/docs/guides-and-surveys/sdk
export const addEngagementPlugin = (add: (plugin: unknown) => void) => {
  add(engagementPlugin());
};
